import { useTranslation } from 'react-i18next';
import { TranslatedCalling } from './common';

function RememberAboutUserResult({ toolCall }: { toolCall: any }) {
  const { t } = useTranslation('chat');
  return (
    <div className="my-4 text-gray-900 text-sm font-medium relative">
      {toolCall.result?.success ? (
        <div>
          {t('tool.remember-about-user.stored', { stored: toolCall.result.stored })}
          {toolCall.result.embeddingCount && (
            <div className="text-xs text-gray-500 mt-1">
              {t('tool.remember-about-user.created-embeddings', { count: toolCall.result.embeddingCount })}
            </div>
          )}
        </div>
      ) : (
        <div className="text-red-600">
          {t('tool.remember-about-user.failed-to-store', {
            error: toolCall.result?.error || t('tool.remember-about-user.unknown-error'),
          })}
        </div>
      )}
    </div>
  );
}

export const rememberAboutUser = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.remember-about-user.updating" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.remember-about-user.updating" />,
  result: (toolCall: any) => <RememberAboutUserResult toolCall={toolCall} />,
};
